import { PriceChangeType } from "@/graphql/codegen/graphql"
import { RecipientType } from "@/screens/Pricing/constants/index"

export const priceChangeTypeLabelMap = new Map<PriceChangeType, string>([
  [PriceChangeType.PurchasingCost, "Purchasing Cost"],
  [PriceChangeType.SellingPrice, "Selling Price"],
])

export const recipientTypeTypeLabelMap = new Map<RecipientType, string>([
  [RecipientType.Customer, "Customer"],
  [RecipientType.Contact, "Contact"],
])
